module.exports = __webpack_public_path__ + "media/application/images/svgs/ah_logo-3abb4f5e9046b1c9d0ad7aa145b1ae64.svg";